import Navigation from '../../components/layout/Navigation';
import Footer from '../../components/layout/Footer';
import Hero from '../../components/ui/Hero';
import GenesisSection from './components/GenesisSection';
import DNASection from './components/DNASection';
import MilestonesSection from './components/MilestonesSection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      {/* 
        Using simple styling for Hero to avoid mobile layout issues. 
        Ensuring text is visible against background.
      */}
      <Hero 
        subtitle="Our Story, Our Vision"
        title={<>More Than Just a Company. <span className="gradient-text">We're Digital Pioneers.</span></>}
        description="Discover the passion, purpose, and people behind Hash Adz Creative Consultants, transforming visions into digital realities."
        bgImage="/assets/diverse-creative-team.png"
        primaryBtn={{ text: "Discover Our Journey", link: "/contact", icon: "ri-arrow-down-line" }}
      />
      <div className="relative z-10 bg-black">
        <GenesisSection />
        <DNASection />
        <MilestonesSection />
      </div>
      <Footer />
    </div>
  );
}